import React, { useState, useEffect } from "react";
import { string, object, array } from "prop-types";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { connect } from "react-redux";

import CardImage from "../../atoms/CardImage";
import ScrollSnap from "../../atoms/ScrollSnap";
import RightArrowButton from "../../atoms/icons/right-arrow-button";
import LeftArrowButton from "../../atoms/icons/left-arrow-button";
import StoryMetaData from "../../molecules/StoryMetaData";
import Organism1 from "../BigPhotoStoryCardSlider1Ad/Organism1";
import DfpAd from "../../dfp-ad";
import NewsHeadline from "../../atoms/NewsHeadline";

import { getSlug } from "../../utils/utils";

import "./bigPhotoStoryCardSlider1Ad.m.css";

const BigPhotoStoryCardSlider1Ad = ({ collection, className = "", sections, lang, domainSlug }) => {
  const stories =
    collection.items.length > 0 && collection.items.filter((item) => item.type === "story").map((item) => item.story);

  if (!stories.length) {
    return null;
  }
  const showStoriesWithAd = get(collection, ["associated-metadata", "show_stories_Ad"], true);
  const firstStory = stories[0];
  const remainingStories = stories.slice(1, stories.length);
  const [photoElements, setPhotoElements] = useState(null);
  const [isDesktop, setIsDesktop] = useState(false);
  const collectionSlug = getSlug(collection, sections, domainSlug);
  const adSlotId1 = get(collection, ["associated-metadata", "ad_slot_id1"], "default_ad_slot1");
  const adSlotId2 = get(collection, ["associated-metadata", "ad_slot_id2"], "default_ad_slot2");

  useEffect(() => {
    setIsDesktop(global.deviceWidth > 1263);
    processPhotoElements();
  }, []);

  function processPhotoElements() {
    const children = [];

    if (firstStory.cards && firstStory.cards.length) {
      firstStory.cards.forEach((card) => {
        const imageList = card["story-elements"].filter((element) => element.type === "image");
        if (imageList && imageList.length) {
          imageList.forEach((item) => {
            const storyCardObj = {
              "hero-image-s3-key": item["image-s3-key"],
              "hero-image-metadata": item["image-metadata"],
              "hero-image-caption": item.title,
            };

            children.push(
              <div key={item.id}>
                <Link aria-label={firstStory.headline} href={firstStory.url}>
                  <CardImage
                    story={storyCardObj}
                    key={item.id}
                    aspectRatio={[16, 9]}
                    imageType="image16x9"
                    widths={[1000]}
                    showAlternateImage={true}
                  />
                </Link>
              </div>
            );
          });
        }
      });
    }
    setPhotoElements(children);
  }

  function textDataRender(firstStory) {
    return (
      <div>
        <NewsHeadline story={firstStory} cssStyleName="bigSize" />
        <StoryMetaData story={firstStory} />
      </div>
    );
  }

  if (!photoElements) {
    return null;
  }

  return (
    <div styleName="base" className={className}>
      <div styleName="wrapper">
        <div styleName="image-wrapper">
          {photoElements && photoElements.length ? (
            <ScrollSnap
              leftArrow={<LeftArrowButton />}
              rightArrow={<RightArrowButton />}
              isIndicator={false}
              lang={lang}
            >
              {photoElements}
            </ScrollSnap>
          ) : (
            <Link aria-label={firstStory.headline} href={firstStory.url}>
              <CardImage
                story={firstStory}
                aspectRatio={[16, 9]}
                imageType="image16x9"
                widths={[1000]}
                showAlternateImage={true}
              />
            </Link>
          )}
          {!isDesktop && textDataRender(firstStory)}
        </div>

        <div styleName="content-wrapper">
          {isDesktop && textDataRender(firstStory)}
          <div styleName="side-ad">
            <DfpAd
              adtype="News_336x280_R1"
              collectionSlug={collectionSlug}
              layoutName="BigPhotoStoryCardSlider1Ad"
              slotId={adSlotId1}
            />
          </div>
        </div>
      </div>

      {showStoriesWithAd && (
        <Organism1 stories={remainingStories} collectionSlug={collectionSlug} adSlotId={adSlotId2} />
      )}
    </div>
  );
};

BigPhotoStoryCardSlider1Ad.propTypes = {
  className: string,
  collection: object,
  sections: array,
  lang: string,
  domainSlug: string,
};

BigPhotoStoryCardSlider1Ad.storyLimit = 5;

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
  sections: get(state, ["qt", "config", "sections"], []),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

export default connect(mapStateToProps)(BigPhotoStoryCardSlider1Ad);
